import { privateApi } from './private-api';

export interface MKFCodeDto {
	code: string;
	prefix: string;
	domen: number;
	name: string;
	codes: MKFCodeDto[];
}

export const mkfApi = privateApi.injectEndpoints({
	endpoints: (build) => ({
		getMKFCodes: build.query<MKFCodeDto[], void>({
			query: () => `mkf-code`,
		}),
	}),
	overrideExisting: false,
});

export const { useGetMKFCodesQuery } = mkfApi;
